import React, { useState } from 'react';
import { navigate } from 'gatsby';
import * as Styled from '../demoFormSection/style';

export default function ChatbotDemoForm() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [company, setCompany] = useState('');

  const [error, setError] = useState('');

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhone = (phone) =>
    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone);

  const validateField = (value) =>
    value.trim().length > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (
      !validateField(firstName) ||
      !validateField(lastName) ||
      !validateField(company)
    ) {
      setError('Please fill out all required fields.');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    if (!validatePhone(phone)) {
      setError('Please enter a valid phone number.');
      return;
    }

    const fields = [
      { name: 'firstname', value: firstName },
      { name: 'lastname', value: lastName },
      { name: 'email', value: email },
      { name: 'phone', value: phone },
      { name: 'company', value: company },
    ];

    const response = await fetch('/api/submitHubspotForm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        formId: 'df48709d-8ea8-483e-aa22-278f5b9f8d76',
        fields,
      }),
    });

    if (response.ok) {
      navigate('/ai-chatbot-success');
    } else {


      setError('There was an error submitting the form. Please try again.');

    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Styled.Field>
          <label>First Name*</label>
          <input
            type='text'
            placeholder='First Name*'
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </Styled.Field>

        <Styled.Field>
          <label>Last Name*</label>
          <input
            type='text'
            placeholder='Last Name*'
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </Styled.Field>

        <Styled.Field>
          <label>Email*</label>
          <input
            type='email'
            placeholder='Email*'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Styled.Field>

        <Styled.Field>
          <label>Phone*</label>
          <input
            type='tel'
            placeholder='Phone*'
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </Styled.Field>

        <Styled.Field>
          <label>Company Name*</label>
          <input
            type='text'
            placeholder='Company Name*'
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            required
          />
        </Styled.Field>
      </div>

      <Styled.Button type='submit'>Book my demo</Styled.Button>
    </form>
  );
}
